import { Checkbox, CityState, DataHeader, DataSource, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutResponsibilityCode extends Layout {
    checkboxIsActive: Checkbox;
    cityStateZipAgency: CityState;
    dataheaderResponsibilityCode: DataHeader;
    panelGeneral: Panel;
    panelMain: Panel;
    sourceAgency: DataSource;
    sourceAgencyLink: DataSource;
    tabGeneral: Tab;
    tablUsers: Tab;
    tableResponsibilityUsers: Table;
    tabsetResponsibilityCodes: Tabset;
    textboxAddress1: Textbox;
    textboxAddress2: Textbox;
    textboxAgencyName: Textbox;
    textboxCode: Textbox;
    textboxFaxNumber: Textbox;
    textboxPayee: Textbox;
    textboxPhoneNumber: Textbox;
    textboxSalespersonId: Textbox;
    textboxWebsite: Textbox;
}
